// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import { input } from '../tests/TestHelpers';

export default class ClearInput extends Component {
  #clickHandler: function;
  #inputHandler: function;
  input: HTMLInputElement;
  activeClass: string = 'flex';
  hiddenClass: string = 'hidden';

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    const input: ?HTMLElement = document.getElementById(pEl.dataset.identifier);
    if (!input || !(input instanceof HTMLInputElement)) {
      throw new Error('Associated input is required');
    }
    this.input = input;

    this.#clickHandler = this.onClick.bind(this);
    this.addEventListener(EventNames.CLICK, this.#clickHandler);

    this.#inputHandler = this.onInput.bind(this);
    this.input.addEventListener(EventNames.INPUT, this.#inputHandler);

    if (this.input.value) {
      this.show();
    }
  }

  /**
   * Executes when the element is clicked
   */
  onClick(): void {
    this.input.value = '';
    input(this.input);
    this.input.focus();
  }

  /**
   * Executes when the user is typing in the associated input field
   */
  onInput(e: Event): void {
    if (!(e.target instanceof HTMLInputElement)) return;

    if (!e.target.value) {
      this.hide();
      return;
    }

    this.show();
  }

  /**
   * Show the trigger element
   */
  show(): void {
    this.el.classList.remove(this.hiddenClass);
    this.el.classList.add(this.activeClass);
  }

  /**
   * Hide the trigger element
   */
  hide(): void {
    this.el.classList.add(this.hiddenClass);
    this.el.classList.remove(this.activeClass);
  }

  /**
   * Destroy all event listeners
   */
  destroy() {
    this.removeEventListener(EventNames.CLICK, this.#clickHandler);
    this.input.removeEventListener(EventNames.INPUT, this.#inputHandler);
    super.destroy();
  }
}
